<script>
  import TrendChart from './TrendChart.vue';

  export default {
    name: 'NetProfitTrends',
    extends: TrendChart,
    data() {
      return {
        chartId: 'netProfitTrends',
        propertyName: 'net_profit',
        label: 'Net Profit',
        curYearColor: '#C93939',
        prevYearColor: '#39C2C9',
      };
    },
  };
</script>
